"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = getStylesheetLoader;
var create_stylesheet_loader_1 = require("./create-stylesheet-loader");
var instance;
function getStylesheetLoader() {
    if (!instance) {
        instance = (0, create_stylesheet_loader_1.default)();
    }
    return instance;
}
//# sourceMappingURL=get-stylesheet-loader.js.map